import Cvc from '@/models/creditCard/cvc';

export default (value: string): boolean => Cvc.isValid(value);
